module.exports = __webpack_public_path__ + "static/media/user-plus-solid.2faa59a2.png";